export default "__VITE_ASSET__4LYNCHXyA4UFB0rokgmWHw__"